import { BoxLeadEntity } from "@modules/boxLead/entities/boxLeadEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export const useBoxLead = (leadId: string) => {
  const { boxLeadApi } = useServicesContext()

  const { data, isLoading } = useSuspenseQuery({
    queryKey: ["boxLead", leadId],
    queryFn: async () => {
      const data = boxLeadApi.getBoxLead(leadId)
      return data
    },
  })

  return {
    data: BoxLeadEntity.fromDto(data),
    isLoading,
  }
}
